import { render, staticRenderFns } from "./EvidenceDialog.vue?vue&type=template&id=d4cfe6fc&scoped=true&"
import script from "./EvidenceDialog.vue?vue&type=script&lang=js&"
export * from "./EvidenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cfe6fc",
  null
  
)

export default component.exports